import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { environment } from '../environments/environment';

import { AnalyticsService } from './services/analytics/analytics.service';
import { TranslateService } from './services/translate/translate.service';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PipesModule } from './pipes/pipes.module';
import { MenuModule } from "./pages/menu/menu.module";
import { IbexErrorService } from './services/error/ibex-error.service';
import { ActivityPipe } from './pipes/content/activity.pipe';
import { AlphabetPipe } from './pipes/content/alphabet.pipe';
import { CrossCountrySkiingPipe } from './pipes/content/cross-country-skiing';
import { EventPipe } from './pipes/content/event.pipe';
import { GalleryPipe } from './pipes/content/gallery.pipe';
import { GastroPipe } from './pipes/content/gastro.pipe';
import { HikingPipe } from './pipes/content/hiking';
import { InformationPipe } from './pipes/content/information.pipe';
import { MountainRailwayPipe } from './pipes/content/mountain-railway.pipe';
import { NewsPipe } from './pipes/content/news.pipe';
import { PersonPipe } from './pipes/content/person.pipe';
import { RestaurantPipe } from './pipes/content/restaurant.pipe';
import { TemperaturePipe } from './pipes/content/temperature.pipe';
import { TransportPipe } from './pipes/content/transport.pipe';
import { WeatherPipe } from './pipes/content/weather.pipe';
import { WebcamPipe } from './pipes/content/webcam.pipe';
import { PinchZoomModule } from 'ngx-pinch-zoom';
import { CinemaPipe } from './pipes/content/cinema.pipe';
import { OnlineStatusModule } from 'ngx-online-status';
import { OpeningHoursPipe } from './pipes/content/opening-hours.pipe';
import { AccommodationPipe } from './pipes/content/accommodation.pipe';
import { OpeningStatePipe } from './pipes/content/opening-state.pipe';
import { AirportPipe } from './pipes/content/airport.pipe';
import { GlobalComponentsModule } from './components/global-components.module';
import { SocialMediaPipe } from './pipes/content/social-media.pipe';
import { ImportantNumbersPipe } from './pipes/content/important-numbers.pipe';
import { StreetConditionsPipe } from './pipes/content/street-conditions.pipe';
import { SocialMediaFeedPipe } from './pipes/content/social-media-feed.pipe';
import { MountainRailwayNewPipe } from './pipes/content/mountain-railway-new.pipe';
import { IbexIconModule } from '@ibexfusion/ibex-icon';
import { PublicTransportPipe } from "./pipes/content/public-transport.pipe";
import { PinboardPipe } from './pipes/content/pinboard.pipe'

if (!environment.production) { // develop with live url or local
  /* ------------------- */
  /* enable for live environment in development mode */
  environment.backendUrl = environment.developOnLive.backendUrl;
  /* ------------------- */
}

@NgModule({
  declarations: [
    AppComponent,
    ActivityPipe,
    AlphabetPipe,
    CinemaPipe,
    CrossCountrySkiingPipe,
    EventPipe,
    GalleryPipe,
    GastroPipe,
    HikingPipe,
    InformationPipe,
    MountainRailwayPipe,
    MountainRailwayNewPipe,
    NewsPipe,
    PersonPipe,
    RestaurantPipe,
    TemperaturePipe,
    TransportPipe,
    WeatherPipe,
    WebcamPipe,
    OpeningHoursPipe,
    AccommodationPipe,
    OpeningStatePipe,
    AirportPipe,
    SocialMediaPipe,
    SocialMediaFeedPipe,
    ImportantNumbersPipe,
    StreetConditionsPipe,
    PublicTransportPipe,
    PinboardPipe
  ],
  entryComponents: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    RouterModule,
    CommonModule,
    FormsModule,
    PipesModule,
    MenuModule,
    PinchZoomModule,
    OnlineStatusModule,
    GlobalComponentsModule,
    IbexIconModule
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: IbexErrorService
    },
    AnalyticsService,
    TranslateService
  ],
  bootstrap: [AppComponent],
  exports: []

})
export class AppModule {}

